/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCarrierActivity.ts               *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/crm/carrier-activity";

export class AutogenModelCarrierActivity<RowType extends ModelRow> extends Endpoint<RowType, RowCarrierActivityFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowCarrierActivity extends ModelRow<RowCarrierActivityFields> {
	constructor(values?: Partial<RowCarrierActivityFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowCarrierActivityFields {
	allow_auto_date: string;
	assigned_user_id: string;
	company_id: string;
	days: number;
	def_assign: string;
	descr: string;
	id: string;
	info_packet_id: string;
	next_id: string;
	type_of: string;
}

